import {
  createContext, useContext, useEffect, useMemo, useState
} from 'react';

import PropTypes from 'prop-types';

import { useLessonData } from './index';

const LessonValuesCtx = createContext();

export const useLessonValues = () => {
  const ctx = useContext(LessonValuesCtx);
  if (!ctx) {
    throw new Error('useLessonValues must be used within the LessonProvider');
  }

  return ctx;
};

/* React context guides
    - https://levelup.gitconnected.com/react-context-the-definitive-guide-to-best-practices-fd095568be03
    - https://devtrium.com/posts/how-use-react-context-pro
*/
export const LessonProvider = ({ children }) => {
  const [activeLesson, setActiveLesson] = useState('');
  const { loadLessonValues, getLessonValues, getLessonValue } = useLessonData();

  const lessonCtxValues = useMemo(() => ({
    setActiveLesson,
    getLessonValues,
    getLessonValue
  }), [getLessonValues, getLessonValue]);

  useEffect(() => {
    loadLessonValues(activeLesson);
  }, [loadLessonValues, activeLesson]);

  return (
    <LessonValuesCtx.Provider value={lessonCtxValues}>
      {children}
    </LessonValuesCtx.Provider>
  );
};

LessonProvider.propTypes = {
  children: PropTypes.node.isRequired
};
